import "./awards-section-styles.scss";

// importing icons
import { FiAward } from "react-icons/fi";

// import components
import SectionHeadingComponent from "../../components/section-heading-component/section-heading-component";
import SectionSubHeadingComponent from "../../components/section-sub-heading-component/section-sub-heading-component";
import BadgesComponent from "../../components/badges-component/badges-component";

const AwardsSection = () => {
	return (
		<section id="awards-section" className="awards-section">
			<div className="awards-section-content-wrapper">
				<SectionSubHeadingComponent
					icon={<FiAward />}
					text="Achievements"
				/>
				<SectionHeadingComponent text="A Collection of Awards and Recognitions" />

                <BadgesComponent />
			</div>
		</section>
	);
};

export default AwardsSection;
